<p-dialog modal="true" styleClass="atlas-dialog-s" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{
      !activity.CertificationActivityID
      ? ('certification.edit-ceu-dialog.add-title' | translate)
      : ('certification.edit-ceu-dialog.edit-title' | translate)
      }}
    </h4>
  </ng-template>
  <form #ceuForm="ngForm">
    <div class="mct-flex mct-row mct-grid mct-cols-2-1 mct-gap-27" gdRows="!">
      <div class="mct-flex mct-col">
        <label class="light-text">{{ 'certification.edit-ceu-dialog.source' | translate | titlecase }}*</label>
        <p-select #source [(ngModel)]="activity.CertificationActivitySourceID"
          placeholder="{{ 'certification.edit-ceu-dialog.select-source' | translate }}" [options]="activitySources"
          appendTo="body" [style]="{ width: '100%' }" required name="ceuSource" optionLabel="Name"
          optionValue="CertificationActivitySourceID"></p-select>
      </div>
      <div class="mct-flex mct-col">
        <label class="light-text">{{ 'certification.edit-ceu-dialog.date' | translate | titlecase }}*</label>
        <wl-date-selector ngDefaultControl [(ngModel)]="activity.ActivityDate" appendTo="body" [required]="true"
          name="activityDate"></wl-date-selector>
      </div>
      <div class="mct-flex mct-col">
        <label class="light-text">{{ 'certification.edit-ceu-dialog.type' | translate | titlecase }}*</label>
        <p-select [(ngModel)]="activity.CECreditTypeID"
          placeholder="{{ 'certification.edit-ceu-dialog.select-type' | translate }}" [options]="creditTypes"
          appendTo="body" [style]="{ width: '100%' }" required name="creditType" optionLabel="CECreditType"
          optionValue="CECreditTypeID"></p-select>
      </div>
      <div class="mct-flex mct-col">
        <label class="light-text">{{ 'certification.edit-ceu-dialog.credits-earned' | translate | titlecase }}*</label>
        <input type="number" [(ngModel)]="activity.CEUs" class="form-control" required minlength="1" name="ceus" />
      </div>
      <div *ngIf="activity.CertificationActivityID">
        <div [ngClass]="activity.ExpirationDate <= today ? 'red-text f-wb' : ''">
          {{
          activity.ExpirationDate <= today ? ('certification.expired-on' | translate | ucfirst) :
            ('certification.will-expire-on' | translate | ucfirst) }}{{ activity.ExpirationDate | date: 'M/d/yyyy' }}
            </div>
        </div>
      </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch">
      <button class="atlas-btn atlas-btn-secondary tall mr-10" (click)="cancel()">{{ 'common.cancel' | translate |
        uppercase
        }}</button>
      <button class="atlas-btn atlas-btn-primary tall" (click)="save()" [disabled]="ceuForm.invalid">
        {{ 'common.save' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
